<template>
  <div class="dsf_search_column" v-if="isDesign">
    <div class="item_inner">
      <!-- @click="$emit('toDetail', item.id)" -->
      <div class="item-left-img">
        <dsf-image :src="'' | imgFormat" :error-src="dsf.config.setting_nc_image_default_img" />
        <span class="item-type">课程</span>
        <span class="item-time">
          <dsf-icon name="shijian" />
          00:20:21
        </span>
      </div>
      <div class="item-right-desc">
        <div class="title">
          <span class="name ellipsis-2">我是一个标题</span>
          <span class="task">任务</span>
        </div>
        <p class="item-teacher-name">
          <span>张三</span>
          <span>项目经理</span>
        </p>
        <ul class="item-bottom-desc">
          <li>
            <dsf-icon name="shijian" />
            5学时
          </li>
          <li>
            <dsf-icon name="dianzan_kuai" />
            10
          </li>
          <li>
            <dsf-icon name="pinglun" />
            15
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="dsf_search_column" v-else>
    <div class="item_inner">
      <div class="item-left-img" @click="toDetail(data)">
        <dsf-image :src="data['cover'] | imgFormat" :error-src="dsf.config.setting_nc_image_default_img" />
        <span class="item-type">{{ data.typename }}</span>
      </div>
      <div class="item-right-desc">
        <div class="title">
          <span class="name ellipsis-2">{{ data.title }}</span>
        </div>
        <p class="item-name">
          <span>{{ data.position || "" }}</span>
        </p>
        <!-- <ul class="item-bottom-desc">
          <li>{{ data.clickcs || 0 }}人参与</li>
        </ul> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "dsfSearchTeacherColunm",
  ctrlCaption: "师资卡片",
  props: {
    // 跳转方式
    clickConfig: {
      type: Object,
      default: null,
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    curColor() {
      return this.$root.currentTheme["normal"];
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    toDetail(item) {
      this.$emit("toDetail", { name: "teacher", id: item.id });
    },
  },
};
</script>
